<template>
  <div id="my-msg">
    <div class="top-title">
      <img
        src="../../assets/img/login-img/3-1档案-返回ic@2x.png"
        alt=""
        class="back-icon"
        @click="goBack"
      >
      <p class="title-text">消息</p>
      <p class="right-text" v-show="isDelect" @click="isDelect = false">取消</p>
      <div v-if="msgList.length!==0">
        <img
          src="../../assets/img/login-img/3-3file-delectic@2x.png"
          alt=""
          class="right-icon"
          @click="isDelect = true"
          v-show="!isDelect"
        >
      </div>
    </div>
    <div class="nomsgBG" ref="msgScrollRef" v-if="msgList.length == 0">
      <img src="@/assets/img/login-img/3-1档案-404@2x.png" alt="" class="nomsg">
      <div class="nomsgTxt" @click="goDoctor">暂无消息，快去撩撩吧~</div>
    </div>
    <div class="msg-list msg-scroll" ref="msgScrollRef">
      <ul class="msg-bg">
        <li
          class="msg-item"
          :class="[v.isRead == 0? '': 'readed']"
          @click="isDelect ? onClick(v,k) : goChat(v, k)"
          v-for="(v, k) in msgList"
          :key="k"
          v-if="v.trade_status != 0 && (v.trade_status == 1? (v.doctor_name == null? false: true) : true)"
        >
          <div class="select-button-box" v-show="isDelect">
            <img
              src="../../assets/img/login-img/3-4file-select@2x.png"
              alt=""
              class="select-button"
              v-show="delectList.includes(v.id)"
            >
            <img
              src="../../assets/img/login-img/3-4file-noselect.png"
              alt=""
              class="select-button"
              v-show="!delectList.includes(v.id)"
            >
          </div>
          <div class="news-area">
            <div class="msg-title">{{v | newcontent}}</div>
            <div class="msg-time">{{v.created | timeFilter}}</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="bottom-button" v-if="isDelect">
      <div class="bottom-left" v-show="true" @click="allSelect">
        <img
          src="../../assets/img/login-img/3-4file-noselect.png"
          alt=""
          class="select-icon"
          v-show="!allSelectFlag"
        >
        <img
          src="../../assets/img/login-img/3-4file-select@2x.png"
          alt=""
          class="select-icon"
          v-show="allSelectFlag"
        >
        <p class="select-text siyuan-bold">全选</p>
      </div>
      <div class="bottom-right">
        <van-button size="large" class="right-button" @click="deletNews">删除</van-button>
      </div>
    </div>
  </div>
</template>
<script>
  import api from "@/api/index";
  import BScroll from "better-scroll";
  export default {
    data() {
      return {
        isDelect: false,
        delectList: [],
        allSelectFlag: false,
        msgList: [],
        page: 1,
        number: 9,
        msgScroll: null
      };
    },
    beforeCreate() {},
    created() {
      this.init();
      this.$nextTick(() => {
        this.initScroll();
      });
    },
    beforeMount() {},
    mounted() {},
    // filter的第一个参数是"|"前面的那个数
    filters: {
      newcontent(v) {
        if (v.type == 1) {
          return `${v.doctorname} 医生已经回复了您的图文咨询，快去查看吧！`;
        } else if (v.type == 2) {
          return `退款成功! 您购买 ${v.doctorname} 医生的图文咨询，${v.amount /
            100}元已退回到您的账户！`;
        } else if (v.type == 3) {
          return `您和 ${v.doctorname} 医生的图文咨询已经结束，去给医生打个分吧`;
        }
      },
      timeFilter(timestamp) {
        let time = Date.now();
        let flag = timestamp || time;
        let date = new Date();
        if (flag.length === 10) {
          date = new Date(flag * 1000); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        } else if (flag.length === 13) {
          date = new Date(flag);
        }
        let Y = date.getFullYear() + "-";
        let M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        let D = date.getDate() + " ";
        let h = date.getHours() + ":";
        let m = date.getMinutes() + ":";
        let s = date.getSeconds();
        return Y + M + D + h + m + s;
      }
    },
    methods: {
      init() {
        this.getMsg();
      },
      initScroll() {
        const options = {
          click: true,
          probeType: 2,
          scrollY: true,
          pullUpLoad: {
            threshold: -50
          }
        };
        this.msgScroll = new BScroll(this.$refs.msgScrollRef, options);
        this.msgScroll.on("pullingUp", () => {
          this.nextPage();
          this.msgScroll.finishPullUp();
        });
      },
      goBack() {
        if (this.$route.query.from) {
          this.$router.push(this.$route.query.from);
        } else if (this.backPath) {
          this.$router.push(this.backPath);
        } else {
          this.$router.push("/SdUserInfo");
        }
      },
      onClick(item) {
        let flag = this.delectList.indexOf(item.id);
        if (flag === -1) {
          this.delectList.push(item.id);
        } else {
          this.delectList.splice(flag, 1);
        }
      },
      // 待完成全选
      allSelect() {
        this.allSelectFlag = !this.allSelectFlag;
        if (this.allSelectFlag) {
          this.delectList.splice(0);
          this.msgList.map((item, index) => {
            this.delectList.push(item.id);
          });
        } else {
          this.delectList.splice(0);
        }
      },
      // 待完成删除
      deletNews() {
        let url = api.deletenews;
        let params = {
          uid: localStorage.getItem("uid") || "",
          news_ids: this.delectList
        };
        this.$http
          .post(url, this.$ObjToFd(params))
          .then(res => {
            if (res.data.code == 0) {
              this.$toast("删除成功");
              this.delectList = [];
              this.allSelectFlag = false;
              this.page = 1;
              this.msgList = [];
              this.getMsg();
              this.isDelect = false;
            } else {
              this.$toast(res.data.message);
            }
          })
      },
      goChat(v, k) {
        let params = {
          userToken: localStorage.getItem("token"),
          nid: v.id
        };
        if (v.type == 2 && v.isRead == 1) {
          this.$router.push("/SdAskOrder");
          return false;
        } else {
          this.$http.post(api.readnews, this.$ObjToFd(params)).then(res => {
            if (res.data.code == 0) {
              this.msgList[k].isRead = 1;
              if (v.type == 2) {
                this.$router.push("/SdAskOrder");
              } else {
                this.$router.push({
                  path: "/SdAskChat",
                  query: {
                    orderId: v.order_number
                  }
                });
              }
            } else {
              this.$toast("服务器出错，请重新登录再试~");
            }
          });
        }
      },
      goDoctor() {
        this.$router.push("SdAskDoctor");
      },
      nextPage() {
        this.page++;
        this.getMsg();
      },
      getMsg() {
        let url = `${api.getnews}?page=${this.page}&number=${this.number}`;
        const toast = this.$toast({
          mask: true,
          message: "正在加载...",
          duration: 1500
        });
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            if (res.data.news.length !== 0) {
              this.msgList = this.msgList.concat(res.data.news);
              toast.clear();
            } else {
              this.$toast({
                message: "已经没有更多消息了~",
                duration: 1000
              });
            }
          } else {
            this.$toast({
              message:
                res.data.message || res.data.error || res.data.err || "加载出错~",
              duration: 1000
            });
          }
        });
      }
    }
  };
</script>
<style lang="less">
  #my-msg {
    height: 100%;
    & .top-title {
      position: relative;
      width: 100%;
      padding: 27px 0;
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 999;
      display: flex;
      justify-content: center;
      /* border-bottom: 1px solid #fffffd; */
      background-color: #fffffd;
      box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
      &::after {
        position: absolute;
        bottom: 0;
        content: "";
        display: block;
        width: 100%;
        height: 1px;
        border: 1px solid rgba(215, 215, 215, 1);
        transform: scaleY(0.3);
      }
      & .back-icon {
        width: 17px;
        height: 34px;
        position: absolute;
        left: 30px;
      }
      & .title-text {
        font-size: 34px;
        font-family: "SourceHanSansCN Medium";
        font-weight: 400;
      }
      & .right-text {
        position: absolute;
        right: 30px;
        color: #37bd37;
        font-size: 30px;
      }
      & .right-icon {
        position: absolute;
        right: 30px;
        width: 32px;
        height: 32px;
      }
    }
    & .nomsgBG {
      & .nomsg {
        width: 33%;
        display: block;
        margin: 0px auto;
        padding-top: 120px;
      }
      & .nomsgTxt {
        text-align: center;
        border: 2px solid #80ca73;
        background-color: #80ca73;
        color: #fff;
        border-radius: 10px;
        margin: 10px 180px;
        padding: 20px 0;
      }
      font-size: 30px;
      margin-top: 87px;
      height: 90%;
    }
    & .msg-list.msg-scroll {
      font-size: 30px;
      margin-top: 87px;
      height: 90%;
      & .msg-bg {
        padding: 0 30px;
        & .msg-item {
          position: relative;
          color: #333333;
          padding: 30px 0 40px;
          display: flex;
          align-items: center;
          & .select-button-box {
            & .select-button {
              width: 40px;
              margin-right: 45px;
            }
          }
          & .msg-title {
            line-height: 42px;
          }
          & .msg-time {
            margin-top: 30px;
            font-size: 22px;
          }
        }
        & .msg-item::after {
          position: absolute;
          bottom: 0;
          content: "";
          display: block;
          width: 100%;
          height: 1px;
          border: 1px solid rgba(215, 215, 215, 1);
          transform: scaleY(0.3);
        }
        // & .msg-item:last-child::after {
        //   border: none;
        // }
        & .readed {
          color: #999999;
        }
      }
    }
    & .bottom-button {
      width: 100%;
      height: 88px;
      position: fixed;
      bottom: 0;
      margin-top: 88px;
      display: flex;
      border: none;
      background-color: #fffffd;
      box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
      z-index: 999999;

      & .van-button--default {
        background-color: #fffffd;
        border: none;
      }
      & .bottom-left {
        border-right: 1px solid #d7d7d7;
        font-size: 32px;
        color: #666666;
        width: 220px;
        display: flex;
        align-items: center;
        padding-left: 30px;
        & .select-icon {
          margin-right: 20px;
          width: 40px;
        }
      }
      & .bottom-right {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        & .right-button {
          font-size: 32px;
          color: #37bd19;
          height: 100%;
        }
      }
    }
    & .activeDelect {
      margin: 0 30px;
    }
    & .onDelete {
      margin-bottom: 50px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/shenduUserInfo/SdMsg.vue